import { render, staticRenderFns } from "./PaperSize.vue?vue&type=template&id=6e64245b&"
import script from "./PaperSize.vue?vue&type=script&lang=ts&"
export * from "./PaperSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports